/** @format */

import {ReactNode} from 'react';

import {Navigate} from 'react-router-dom';
import {LinearProgress} from '@mui/material';

import {useIsSpecialist} from 'helpers/hooks/useIsSpecialist';

interface Props {
  children: ReactNode;
}

/**
 * Гейт для страниц, доступных только владельцу аккаунта.
 * Специалиста (sub-аккаунт, приглашённый по email) редиректит на настройки.
 * Fail closed: если роль не удалось подтвердить (ошибка запроса) — тоже редиректим.
 */
const OwnerRoute = ({children}: Props) => {
  const {loading, error, isSpecialist} = useIsSpecialist();

  if (loading) {
    return <LinearProgress style={{flex: 1}} />;
  }

  if (error || isSpecialist) {
    return <Navigate to='/home/settings' replace />;
  }

  return children;
};

export default OwnerRoute;
